import { LocalLink as Link } from '@/lib/locale';
import { useTranslation } from 'react-i18next';
import { openCookieSettings } from '@/lib/consent';
import { INFO_PAGES } from '@/lib/infoPages';

const linkCls = 'inline-flex min-h-[32px] items-center text-candy-ink-muted transition-colors hover:text-candy-ink';

export const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const columns = [
    {
      title: t('footer.shop'),
      links: [
        { to: '/shop', label: t('footer.allProducts') },
        { to: { pathname: '/', hash: '#bears' }, label: t('footer.bundles') },
      ],
    },
    {
      title: t('footer.information'),
      withCookies: true,
      links: INFO_PAGES.map(({ path, key }) => ({ to: path, label: t(`info.${key}.link`) })),
    },
  ];

  return (
    <footer className="mx-auto mt-10 max-w-content px-4 md:px-6" data-testid="footer">
      <div className="flex flex-wrap items-start justify-between gap-8 border-t-2 border-candy-ink pb-8 pt-10">
        <div className="max-w-[340px]">
          <span className="font-heading text-2xl font-extrabold tracking-[-0.02em]">Blissful Play</span>
          <p className="mt-2.5 text-candy-ink-muted">{t('footer.tagline')}</p>
        </div>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-12 gap-y-6 text-[15px]">
          {columns.map((col) => (
            <div key={col.title} className="flex flex-col gap-1">
              <strong className="mb-1">{col.title}</strong>
              {col.links.map((l) => (
                <Link key={l.label} to={l.to} className={linkCls}>
                  {l.label}
                </Link>
              ))}
              {col.withCookies && (
                <button type="button" onClick={openCookieSettings} className={`${linkCls} text-left`} data-testid="footer-cookie-settings">
                  {t('footer.cookies')}
                </button>
              )}
            </div>
          ))}
        </nav>
        <p className="mt-2 basis-full text-[13px] text-candy-ink-muted">
          © {year} Blissful Play · {t('footer.adults')}
        </p>
      </div>
    </footer>
  );
};
